/**
 * Navigation Metrics
 * Leverages @rei/metrics instance - currently initialized in the footer.js (from monolith)
 * Stop-gap until new implementation of analytics and/or @rei/metrics is finalized.
 */
import { anchorOrButtonEvents, inputEvents } from '@rei/click-event-pubsub';

// check if the user is closing an open menu
const hasBeenClickedMap = new Set();
const hasBeenClicked = (linkName) => {
  if (hasBeenClickedMap.has(linkName)) {
    return true;
  }

  hasBeenClickedMap.add(linkName);
  return false;
};

/**
 * Assumes the subscriber element has a 'data-analytics-id' attribute, and uses this to build
 * the analytics config (aka linkName). Then triggers metrics.link with that config.
 * @param e - click event
 * @param {object} subscriber - anchor, button, or input element subscribed to a click event
 * @param {object} navElem - a single common-component or section of the DOM to limit scope
 */
export const analyticsClickHandler = (navElem, e, subscriber) => {
  const { metrics } = window;
  if (metrics && navElem.contains(subscriber)) {
    const linkName = (subscriber.dataset || {}).analyticsId;

    if (!hasBeenClicked(linkName) && linkName !== 'rei_nav:' && typeof linkName !== 'undefined') {
      metrics.link({ linkName }, e);
    }
  }
};

/**
 * Triggers metrics.link using a customConfig object. Mainly used for tracking analytics
 * on markup generated by JavaScript. Ex. the search box - auto-suggest and most recent searches.
 * @param {object} customConfig
 */
export const analyticsCustomClickHandler = (customConfig) => {
  const { metrics } = window;
  if (metrics) {
    metrics.link(customConfig);
  }
};

const init = (navSelector = null) => {
  const navElem = document.querySelector(navSelector);
  /* Exit if navSelector is not found */
  if (navElem === null) {
    return;
  }
  anchorOrButtonEvents.push(analyticsClickHandler.bind(null, navElem));
  /* inputEvents for search box */
  inputEvents.push(analyticsClickHandler.bind(null, navElem));
};
export default init;
